const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : '/api';

let tracked = false;

export function trackPageview() {
  if (tracked) return;
  tracked = true;

  const data = {
    path: window.location.pathname + window.location.hash,
    referrer: document.referrer || null,
    screen_width: window.innerWidth,
  };

  // Use sendBeacon for non-blocking, or fallback to fetch
  const payload = JSON.stringify(data);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API}/track`, new Blob([payload], { type: 'application/json' }));
  } else {
    fetch(`${API}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
}

// Track section scrolls
export function trackSection(sectionId) {
  const data = {
    path: `/#${sectionId}`,
    referrer: null,
    screen_width: window.innerWidth,
  };

  const payload = JSON.stringify(data);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(`${API}/track`, new Blob([payload], { type: 'application/json' }));
  } else {
    fetch(`${API}/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }
}
